import { Action } from "@ngrx/store";

export enum CustomerActionTypes {
  GET_CUSTOMER_LIST = "[Customers] Get Customer List",
  GET_CUSTOMER_LIST_SUCCESS = "[Customers] Get Customer List Success",
  GET_CUSTOMER_LIST_FAILURE = "[Customers] Get Customer List Error",
  CLEAR_CUSTOMER_LIST = "[Customers] Clear Customer List",

  GET_CUSTOMER = "[Customer] Get Customer by Id",
  GET_CUSTOMER_SUCCESS = "[Customer] Get Customer by Id Success",
  GET_CUSTOMER_FAILURE = "[Customer] Get Customer by Id Error",

  CREATE_CUSTOMER = "[Customer] Create customer",
  CREATE_CUSTOMER_SUCCESS = "[Customer] Create customer Success",
  CREATE_CUSTOMER_FAILURE = "[Customer] Create customer Failure",

  CREATE_CUSTOMER_COMPANY = "[Customer] Create customer company",
  CREATE_CUSTOMER_COMPANY_SUCCESS = "[Customer] Create customer company Success",
  CREATE_CUSTOMER_COMPANY_FAILURE = "[Customer] Create customer company Failure",

  CREATE_CUSTOMER_ADDRESS = "[Customer] Create customer address",
  CREATE_CUSTOMER_ADDRESS_SUCCESS = "[Customer] Create customer address Success",
  CREATE_CUSTOMER_ADDRESS_FAILURE = "[Customer] Create customer address Failure",

  UPDATE_CUSTOMER = "[Customer] Update customer",
  UPDATE_CUSTOMER_SUCCESS = "[Customer] Update customer Success",
  UPDATE_CUSTOMER_FAILURE = "[Customer] Update customer Failure",

  UPDATE_CUSTOMER_COMPANY = "[Customer] Update customer company",
  UPDATE_CUSTOMER_COMPANY_SUCCESS = "[Customer] Update customer company Success",
  UPDATE_CUSTOMER_COMPANY_FAILURE = "[Customer] Update customer company Failure",

  UPDATE_CUSTOMER_ADDRESS = "[Customer] Update customer address",
  UPDATE_CUSTOMER_ADDRESS_SUCCESS = "[Customer] Update customer address Success",
  UPDATE_CUSTOMER_ADDRESS_FAILURE = "[Customer] Update customer address Failure",
}

export class GetCustomerList implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER_LIST;
  constructor(public payload: any) { }
}

export class GetCustomerListSuccess implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetCustomerListFailure implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearCustomerList implements Action {
  readonly type = CustomerActionTypes.CLEAR_CUSTOMER_LIST;
  constructor() { }
}

export class GetCustomer implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER;
  constructor(public id: any) { }
}

export class GetCustomerSuccess implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER_SUCCESS;
  constructor(public payload: any) { }
}

export class GetCustomerFailure implements Action {
  readonly type = CustomerActionTypes.GET_CUSTOMER_FAILURE;
  constructor(public payload: any) { }
}

export class CreateCustomer implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER;
  constructor(public payload: any) { }
}

export class CreateCustomerSuccess implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateCustomerFailure implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_FAILURE;
  constructor(public payload: any) { }
}

export class CreateCustomerCompany implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_COMPANY;
  constructor(public payload: any) { }
}

export class CreateCustomerCompanySuccess implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_COMPANY_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateCustomerCompanyFailure implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_COMPANY_FAILURE;
  constructor(public payload: any) { }
}

export class CreateCustomerAddress implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_ADDRESS;
  constructor(public payload: any) { }
}

export class CreateCustomerAddressSuccess implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_ADDRESS_SUCCESS;
  constructor(public payload: any) { }
}

export class CreateCustomerAddressFailure implements Action {
  readonly type = CustomerActionTypes.CREATE_CUSTOMER_ADDRESS_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateCustomer implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER;
  constructor(public payload: any, public id: any) { }
}

export class UpdateCustomerSuccess implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateCustomerFailure implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateCustomerCompany implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_COMPANY;
  constructor(public payload: any, public id: any) { }
}

export class UpdateCustomerCompanySuccess implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_COMPANY_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateCustomerCompanyFailure implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_COMPANY_FAILURE;
  constructor(public payload: any) { }
}

export class UpdateCustomerAddress implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS;
  constructor(public payload: any, public id: any) { }
}

export class UpdateCustomerAddressSuccess implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdateCustomerAddressFailure implements Action {
  readonly type = CustomerActionTypes.UPDATE_CUSTOMER_ADDRESS_FAILURE;
  constructor(public payload: any) { }
}

export type CustomerActions =
  | GetCustomerList
  | GetCustomerListSuccess
  | GetCustomerListFailure
  | ClearCustomerList
  | GetCustomer
  | GetCustomerSuccess
  | GetCustomerFailure
  | CreateCustomer
  | CreateCustomerSuccess
  | CreateCustomerFailure
  | CreateCustomerCompany
  | CreateCustomerCompanySuccess
  | CreateCustomerCompanyFailure
  | CreateCustomerAddress
  | CreateCustomerAddressSuccess
  | CreateCustomerAddressFailure
  | UpdateCustomer
  | UpdateCustomerSuccess
  | UpdateCustomerFailure
  | UpdateCustomerCompany
  | UpdateCustomerCompanySuccess
  | UpdateCustomerCompanyFailure
  | UpdateCustomerAddress
  | UpdateCustomerAddressSuccess
  | UpdateCustomerAddressFailure;
